/** First-party unique-visit gate: at most one POST per browser per UTC day. */

export const VISIT_KEY = "gmh_vday";

export function utcDay(d = new Date()) {
  return d.toISOString().slice(0, 10);
}

export async function recordVisitOnce({ getDay = utcDay, storage, recordVisit }) {
  const day = getDay();
  try {
    if (storage && storage.getItem(VISIT_KEY) === day) return { counted: false };
  } catch {
    return { counted: false };
  }
  try {
    await recordVisit();
  } catch {
    return { counted: false };
  }
  try {
    if (storage) storage.setItem(VISIT_KEY, day);
  } catch {
    /* storage may be unavailable; the server still counted this attempt */
  }
  return { counted: true };
}
